import React from 'react';
import { withStyles, Button, makeStyles } from '@material-ui/core';
import { primaryColor } from '../utils/colors';

const ColorButton = withStyles((theme) => ({
    root: {
        color: 'white',
        backgroundColor: primaryColor,
        fontFamily: 'Lato, sans-serif',
        '&:hover': {
            backgroundColor: primaryColor,
        },
    },
}))(Button);

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: 'auto',
    },
}));

const CustomButton = props => {

    const classes = useStyles();

    return (
        <div>
            <ColorButton variant="contained" disabled={props.disabled} size={props.size} type={props.type} className={classes.margin} onClick={props.onClick} style={props.style} >
                {props.children}
            </ColorButton>
        </div>
    );
};

export default CustomButton;